<template>
<div id="g-page" >
  <!--<table id="g-page-header" border="0" >
    <tr>
      <td id="g-page-header-image" >
       Engage for Members
      </td>
    </tr>
  </table>-->

  <table border="0" class="main-table-screen" >
    <tr>
      <td id="main-table-row1" colspan="3"> 
      </td>
    </tr>
    <tr>
      <td></td>
      <td id="main-table-row2-dialog-container-td">
        <table border="0">
            <tr>
              <td id="dialog-signon" colspan="2" align="left" style="border-top-left-radius:15px; border-top-right-radius:15px;overflow:hidden;">
                <table>
                  <td>
                  <img id="dialog-member-app-logo" src="../../../assets/images/member-app-logo.jpg" style="text-align:bottom;">
                  </td>
                  <td id="dialog-signon-to-engage" >
                  {{ $t("signon.signon") }}
                  </td>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="1" class="dialog-input-field-left" >
                {{ $t("signon.username") }} &nbsp;
              </td>
              <td colspan="1" class="dialog-input-field-right">
                &nbsp;<input type="text" ref="username" name="username" v-model="input.username" v-bind:placeholder="$t('signon.username')" maxlength="40" size="15"/>
              </td>
            </tr>
            <tr>
              <td colspan="1" class="dialog-input-field-left">
                {{ $t("signon.password") }} &nbsp;
              </td>
              <td class="dialog-input-field-right">
                &nbsp;<input type="password" id="password" name="password" v-model="input.password" v-bind:placeholder="$t('signon.password')" maxlength="40" size="15"/>
                <div id="caps">Caps-Lock</div>
              </td> 
            </tr>
            <tr>
              <td colspan="1" class="dialog-input-field-left">
                {{ $t("signon.language") }} &nbsp;
              </td>
              <td class="dialog-input-field-right">
                &nbsp;
                <select name="language" id="language" @change="onChangeLocale($event, 1)" style="width:135px">
                  <option value="en">English</option>
                  <option value="es">Español</option>
                </select>
              </td> 
            </tr>
            <tr>
              <td colspan="2" class="dialog-input-field-change-password">
                <input type="checkbox" 
                name="chkChangeMyPassword"
                v-model="input.changeMyPassword">
                &nbsp;
                <label for="chkChangeMyPassword">{{ $t("signon.changeMyPassword") }}</label>&nbsp;
              </td>
            <tr>
            <tr>
              <td colspan="2" class="dialog-input-field-recover-password" style="text-align:center">
                <router-link to="/members/recover-password" class="dialog-input-field-recover-password">{{ $t("signon.forgotPassword") }}</router-link>
              </td>
            </tr>
            
            <tr>
              <td id="dialog-connect-td" colspan="2" style="border-bottom-left-radius:15px;border-bottom-right-radius:15px">
                <!--<button id="dialog-connect-input" type="button" v-on:click="login" >Connect</button>-->
                <VueLoadingButton
                  aria-label="button"                  
                  class="default-styles dialog-connect-input"
                  :loading="isLoading"
                  :styled="true"
                  @click.native="login" >{{ $t("signon.connect") }} </VueLoadingButton>
              </td>
            </tr>
          </table>

      </td>
      <td >
      </td>
    </tr>
    <tr>
      <td id="main-table-row3" colspan="3" > 
      </td>
    </tr>
  </table>
</div>
</template>

<script>

//import { API } from '../../../api/member-api'
const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

//import { SUPPORT } from '../../../api/member-api'
import messageBox from './../common/message-box'
import VueLoadingButton from "vue-loading-button";
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

export default {
  name: 'signon',
  components: {
    VueLoadingButton
  },
  data() {
    return {
      input: {
          username: "",
          password: "",
          isProcessing: false,
          changeMyPassword:false
      },
      isLoading:false
    }
  },
  /* watch: {
    '$i18n.locale': function(newVal, oldVal) 
    {
      //console.log('locale change', newVal)
      alert(this.$t('c19confirm.header'));
      alert(newVal);
      alert(oldVal);
    }
  }, */
  methods: 
  {
    onEnterClicked : function(event)
    {
      if (event.keyCode === 13) {
        // ADD ENTER KEY HANDLER FOR VIEW
        this.login();
      }
    },
    onChangeLocale(event, source)
    {
      
      if(source==1) // USER TRIGGERED
      {
        this.$i18n.locale = event.target.value;
      }
     
      SUPPORT.hideServiceMenus();
      /* SET THE MENU OPTIONS MANUALLY AS THEY
      DON'T RESET BY THEMSELVES */
      let menuLogoffItem = document.getElementById('menuLogoffItem');
      let menuMedicalHistory = document.getElementById('routerLinkMedicalHistory');
      let menuCOVID19Questionnaire = document.getElementById('routerLinkCOVID19Questionnaire');
      let menuDQQuestionnaire = document.getElementById('routerLinkDailyQuestionnaire');
      let menuDashboard = document.getElementById('routerLinkDashboard');
      let menuMedicalTests = document.getElementById('routerLinkMedicalTests');
      let menuAppointments = document.getElementById('routerLinkAppointments');
      let menuOptionalConsents = document.getElementById('routerLinkOptionalConsents');

      // TRANSLATE MENU ITEMS
      menuLogoffItem.innerText = this.$t('menu.mnuLogoff');
      menuMedicalHistory.innerText = this.$t('menu.mnuMedicalHistory');
      menuCOVID19Questionnaire.innerText = this.$t('menu.mnuC19Questionnaire');
      menuDQQuestionnaire.innerText = this.$t('menu.mnuDQQuestionnaire');
      menuDashboard.innerText = this.$t('menu.mnuDashboard');
      menuMedicalTests.innerText = this.$t('menu.mnuMedicalTests');
      menuAppointments.innerText = this.$t('menu.mnuAppointments');
      menuOptionalConsents.innerText = this.$t('menu.mnuOptionalConsents');
    },
    /* onRecoverPassword()
    {
      alert('hit');
      this.$router.push("/members/recover-password");
    }, */
    addEvents()
    {
      // RE-ADD EVENT HANDLER FOR ENTER KEY
      document.onkeyup = null;
      document.onkeyup = this.onEnterClicked;
    },
    login() 
    {
      // ACCESS ENGAGE
      if(this.input.isProcessing == true)
      {
        // ELIMINATE DUPLICATE CLICKS OR ENTER KEY STROKES
        return;
      }
      this.input.isProcessing = true;

      if(this.input.username != "" && this.input.password != "") 
      {
        this.isLoading = true;

        /* MAKE SIGNON CALL HERE */    
        API.signon(this.input.username, this.input.password, this.$i18n.locale)
        .then(response => {          
          if(response.data.hasError == false)
          {
            
            // SAVE THE SESSION DATA
            window.sessionKey = response.data.sessionKey ;
            window.firstName = response.data.firstName ;
            window.defaultDailyQuestionnaireTypeId = response.data.defaultDailyQuestionnaireTypeId ;

            if(response.data.consentRequired)
            {              
              // REDIRECT TO CHANGE PASSWORD
              this.$router.push( { path: "/members/consent"} );
            }
            else if(response.data.passwordChangeRequired)
            {
              // REDIRECT TO CHANGE PASSWORD
              this.$router.push( { path: "/members/change-password"} );
            }           
            else
            {
              if(this.input.changeMyPassword == true)
              {
                this.$router.push( { path: "/members/change-password"} );
              }
              else
              {
                // REDIRECT TO THE MEMBER HOME PAGE
                if(window.defaultDailyQuestionnaireTypeId == 1) // COVID
                {
                  this.$router.push( { path: "/members/c19-daily-questionnaire"} );
                }
                else if(window.defaultDailyQuestionnaireTypeId == 2)  // FIT FOR DUTY
                {
                  this.$router.push( { path: "/members/daily-questionnaire"} );
                }
                else if(window.defaultDailyQuestionnaireTypeId == 3)  // DASHBOARD
                {
                  this.$router.push( { path: "/members/dashboard"} );
                }
              }
            }
          } 
          else 
          {
            // FAILED TO AUTHENTICATE
            window.sessionKey = '';
            document.onkeyup = null;
            this.$generalMessage(messageBox, response.data.errorMessage, this.addEvents);
            this.isLoading = false;
          }
        })
        .catch(e => {
          // NON API ERROR
          window.sessionKey = '';
          document.onkeyup = null;
          this.$generalMessage(messageBox, e, this.addEvents);
          this.isLoading = false;
        });  
      }
      else
      {
        // MISSING CREDENTIAL INFORMATION
        if(this.input.username == "")
        {
          document.onkeyup = null;
          this.$generalMessage(messageBox, this.$t("signon.enterUsername") /*"You must enter a username."*/, this.addEvents);
          
        }
        else if(this.input.password == "")
        {
          document.onkeyup = null;
          this.$generalMessage(messageBox, this.$t("signon.enterPassword")/*"You must enter a password."*/, this.addEvents);
        }
      }

      // ALLOW CLICKS AGAIN
      this.input.isProcessing = false;
    },
    focusInput() {
      // SET DEFAULT CONTROL
      this.$refs.username.focus();
    }
  },
  mounted () {
  
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);

    
    let output = document.getElementById('caps');
    output.style.display = 'none';

    window.addEventListener('keyup', (event) => {
      if(event.getModifierState('CapsLock')){
          output.style.display = 'block';
      }else {
          output.style.display = 'none';
      }
    });

    //window.addEventListener('keyup', this.setCapsLock);

    if(window.sessionKey != '')
    {
      
      /* CURRENTLY LOGGED IN SO BYPASS LOGON
       * AND GO TO THE MEMBER HOME PAGE */
      //this.$router.push( { path: "/members/c19-daily-questionnaire"} );
      //return;
    }

    // ADD THE INITIAL ENTER KEY HANDLER
    document.onkeyup = this.onEnterClicked;

    this.$i18n.locale = "en";

    this.onChangeLocale(this.$i18n.locale, 0);
    
    // FOCUS ON THE USER NAME
    this.focusInput();
  },
  beforeDestroy()
  {
    document.onkeyup = null;

  },
  /* setCapsLock(event)
  {
    alert('hit');
    let output = document.getElementById('caps');
    output.style.display = 'none';
    if(event.getModifierState('CapsLock')){
        output.style.display = 'block';
    }else {
        output.style.display = 'none';
    }
  } */
}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

#app .default-styles {
  color: white;
  background-color:#4682B4;
  border: solid 1px transparent;
  //border-radius: 4px;
  cursor: pointer;
  padding: 8px 16.5px 8px 16px;
  line-height: 15px;
  vertical-align: top;
  font-size: 14px;
}
/* #app .default-styles:not(:disabled) .spinner span {
  border: 8.4px solid transparent;
  //box-shadow: 0 0 0 0.1rem #fff inset;
 
} */

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  // BEGIN SIGNON DIALOG STYLES
  .main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:52px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:90%;
    padding-left: 10%;
  }
  
  #dialog-signon
  {
    height:52px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-member-app-logo
  {
    height:52px;
    width:50px;
    padding-bottom:0px;
    margin-bottom:0px;
    float:left;
  }
  #dialog-signon-to-engage
  {
    vertical-align:bottom;
    padding-left:8px
  }
  .dialog-input-field-left
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
  }
  .dialog-input-field-right
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
  }
  .dialog-input-field-recover-password
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    text-decoration: underline;
    font-style: italic;
  }
  .dialog-input-field-change-password
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    //text-decoration: underline;
    font-style: italic;
  }
  #dialog-connect-td
  {
    height: 55px;
    width:100%;
    vertical-align: middle !important;
    text-align: center;
    background-color:#343F68 ;
    //padding-right: 20px;
    padding-top: 15px;
  }
  .dialog-connect-input
  {
    color:white;
    background-color:#4682B4 ; 
    vertical-align: middle !important;   
  }
  #main-table-row3
  {
    height:250px;
  }
  
  
  // END SIGNON DIALOG STYLES
}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  // BEGIN SIGNON DIALOG STYLES
  .main-table-screen
  {
    background-color:gray;
    padding: 0px;
    margin: 0px;
    width:100%;
    margin-bottom:0px;
    display:table;
    max-width:100%;
    min-width:100%;
  }
  #main-table-row1
  {
    height:150px; 
  }
  #main-table-row2-dialog-container-td
  {
    width:320px;
  }
  
  #dialog-signon
  {
    height:106px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 15pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: bottom;
  }
  #dialog-member-app-logo
  {
    height:106px;
    width:100px;
    padding-bottom:0px;
    margin-bottom:0px;
    float:left;
  }
  #dialog-signon-to-engage
  {
    vertical-align:bottom;
    padding-left:8px
  }
  .dialog-input-field-left
  {
    height:40px;
    text-align: right !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    padding-right:8px;
    width:15%;
  }
  .dialog-input-field-right
  {
    height:40px;
    width:15%;
    text-align: left !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
  }
  .dialog-input-field-recover-password
  {
    height:50px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    text-decoration: underline;
    font-style: italic;
  }
  .dialog-input-field-change-password
  {
    height:30px;
    width:100%;
    text-align: center !important;
    vertical-align: middle;
    background-color:#343F68;
    color:white;
    //text-decoration: underline;
    font-style: italic;
  }
  #caps
  {
    font-size: 8pt;
    /* color:white;
    font-family:'Arial Black';
    
    font-style:normal; */
    //font-weight: normal;
  }
  #dialog-connect-td
  {
    height: 50px;
    vertical-align: middle;
    text-align: right;
    background-color:#343F68 ;
    padding-right: 20px;
  }
  .dialog-connect-input
  {
    color:white;
    background-color:#4682B4 ;  
    font-size: 12px;  
    height:27px;
    vertical-align: middle;
    
    //width:150px;
  }
  
  
  #main-table-row3
  {
    height:250px;
  }
  
  // END SIGNON DIALOG STYLES

}
</style>